var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn btn-primary",class:_vm.btnClass,attrs:{"disabled":_vm.isLoading},on:{"click":_vm.commitAction}},[(_vm.isLoading)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.localCaption)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }